(function () {
  if (window.MiyabiFacilityVideoModal) return;

  function getYoutubeId(url) {
    try {
      var parsed = new URL(url);
      var host = parsed.hostname.replace(/^www\./, '').replace(/^m\./, '');
      if (host === 'youtu.be') {
        return parsed.pathname.split('/').filter(Boolean)[0] || '';
      }
      if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
        if (parsed.pathname.indexOf('/embed/') === 0) {
          return parsed.pathname.split('/')[2] || '';
        }
        if (parsed.pathname.indexOf('/shorts/') === 0) {
          return parsed.pathname.split('/')[2] || '';
        }
        if (parsed.pathname.indexOf('/live/') === 0) {
          return parsed.pathname.split('/')[2] || '';
        }
        return parsed.searchParams.get('v') || '';
      }
    } catch (error) {
      return '';
    }
    return '';
  }

  function getVimeoId(url) {
    try {
      var parsed = new URL(url);
      var host = parsed.hostname.replace(/^www\./, '');
      if (host === 'player.vimeo.com') {
        var playerParts = parsed.pathname.split('/').filter(Boolean);
        return playerParts[0] === 'video' ? playerParts[1] || '' : '';
      }
      if (host === 'vimeo.com' || host.endsWith('.vimeo.com')) {
        var parts = parsed.pathname.split('/').filter(Boolean);
        for (var i = parts.length - 1; i >= 0; i -= 1) {
          if (/^\d+$/.test(parts[i])) return parts[i];
        }
      }
    } catch (error) {
      return '';
    }
    return '';
  }

  function isDirectVideoUrl(url) {
    try {
      var parsed = new URL(url);
      var path = parsed.pathname.toLowerCase();
      return /\.(mp4|webm|ogg|ogv|m4v)(\/)?$/.test(path);
    } catch (error) {
      return false;
    }
  }

  function resolvePlayer(url) {
    var youtubeId = getYoutubeId(url);
    if (youtubeId) {
      return {
        type: 'iframe',
        src:
          'https://www.youtube.com/embed/' +
          encodeURIComponent(youtubeId) +
          '?autoplay=1&rel=0&modestbranding=1',
      };
    }

    var vimeoId = getVimeoId(url);
    if (vimeoId) {
      return {
        type: 'iframe',
        src: 'https://player.vimeo.com/video/' + encodeURIComponent(vimeoId) + '?autoplay=1',
      };
    }

    if (isDirectVideoUrl(url)) {
      return { type: 'video', src: url };
    }

    // Fallback: treat as embeddable URL (e.g. already an embed link)
    return { type: 'iframe', src: url };
  }

  class FacilityVideoModal {
    constructor() {
      this.modal = null;
      this.player = null;
      this.titleEl = null;
      this.siteLink = null;
      this.lastFocus = null;
      this.onKeyDown = this.onKeyDown.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.init();
    }

    init() {
      this.modal = document.getElementById('FacilityVideoModal');
      if (!this.modal) return;

      this.player = this.modal.querySelector('[data-facility-video-player]');
      this.titleEl = this.modal.querySelector('[data-facility-video-title]');
      this.siteLink = this.modal.querySelector('[data-facility-video-site]');

      document.addEventListener('click', this.onDocumentClick);
    }

    onDocumentClick(event) {
      var trigger = event.target.closest('[data-facility-video-trigger]');
      if (trigger) {
        event.preventDefault();
        this.open(trigger);
        return;
      }

      if (event.target.closest('[data-facility-video-close]')) {
        event.preventDefault();
        this.close();
      }
    }

    onKeyDown(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    open(trigger) {
      if (!this.modal || !this.player) return;

      var name = trigger.getAttribute('data-facility-name') || '紹介動画';
      var videoUrl = (trigger.getAttribute('data-facility-video-url') || '').trim();
      var siteUrl = (trigger.getAttribute('data-facility-site-url') || '').trim();
      if (!videoUrl) return;

      this.lastFocus = document.activeElement;
      this.stopPlayback();

      if (this.titleEl) this.titleEl.textContent = name;

      if (this.siteLink) {
        if (siteUrl) {
          this.siteLink.href = siteUrl;
          this.siteLink.hidden = false;
        } else {
          this.siteLink.removeAttribute('href');
          this.siteLink.hidden = true;
        }
      }

      var resolved = resolvePlayer(videoUrl);
      if (resolved.type === 'video') {
        var video = document.createElement('video');
        video.src = resolved.src;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        this.player.appendChild(video);
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } else {
        var iframe = document.createElement('iframe');
        iframe.src = resolved.src;
        iframe.title = name + 'の紹介動画';
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        iframe.allowFullscreen = true;
        this.player.appendChild(iframe);
      }

      this.modal.hidden = false;
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('facility-video-modal-open');
      document.addEventListener('keydown', this.onKeyDown);

      var closeButton = this.modal.querySelector('.facility-video-modal__close');
      if (closeButton) closeButton.focus();
    }

    stopPlayback() {
      if (!this.player) return;

      var video = this.player.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }

      var iframe = this.player.querySelector('iframe');
      if (iframe) {
        iframe.src = 'about:blank';
      }

      this.player.innerHTML = '';
    }

    close() {
      if (!this.modal || this.modal.hidden) return;

      this.stopPlayback();
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('facility-video-modal-open');
      document.removeEventListener('keydown', this.onKeyDown);

      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        this.lastFocus.focus();
      }
      this.lastFocus = null;
    }
  }

  function boot() {
    window.MiyabiFacilityVideoModal = new FacilityVideoModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
